// extracted by mini-css-extract-plugin
export default {"root":"LoadingView_root__Ge4LK","loader":"LoadingView_loader__g7CMb"};